import { Fonts } from "../realms/types/fonts.type"

const fontsCDN = "https://assets.teachablecdn.com/fonts"

export const fonts = {
    alegreya: {
        family: "Alegreya",
        source: `${fontsCDN}/alegreya/AlegreyaSans-Light.woff`
    },
    lato: { family: "Lato", source: `${fontsCDN}/lato/lato-light.woff` },
    lucidasans: {
        family: "LucidaSans",
        source: `${fontsCDN}/lucida-sans/376F8D_5_0.woff`
    },
    merriweather: {
        family: "Merriweather",
        source: `${fontsCDN}/merriweather/Merriweather.woff`
    },
    metropolis: {
        family: "Metropolis",
        source: `${fontsCDN}/metropolis/Metropolis-Light.woff`
    },
    opensans: {
        family: "OpenSans",
        source: `${fontsCDN}/open-sans/OpenSans.woff`
    },
    raleway: {
        family: "Raleway",
        source: `${fontsCDN}/raleway/Raleway-Light.woff`
    },
    sfprodisplay: {
        family: "SF Pro Display",
        source: `${fontsCDN}/sf-pro-display/SF-Pro-Display-Light.woff`
    },
    sourcesanspro: {
        family: "Source Sans 3",
        source: `${fontsCDN}/source-sans-pro/SourceSansPro-Light.woff`
    },
    arial: { family: "Arial" },
    palatino: { family: "Palatino" },
    nunitosans: { family: "Nunito Sans, -apple-system" },
    helvetica: { family: "Helvetica" },
    georgia: { family: "Georgia" },
    serif: { family: "serif" },
    reckless: {
        family: "Reckless",
        source: `${fontsCDN}/reckless/Reckless-Regular.otf`
    },
    systemui: { family: "system-ui" }
}

const normalizeFontName = (font: string): string => {
    return font.toLowerCase().replaceAll(" ", "").replaceAll("-", "")
}

export const getFontFamily = async (
    font: Fonts
): Promise<string | undefined> => {
    const fontType = normalizeFontName(font)

    const selectedFont = fonts[fontType]

    if (!selectedFont) {
        return
    }

    if (!selectedFont.source) {
        return selectedFont.family
    }

    const myFont = new FontFace(
        selectedFont.family,
        `url(${selectedFont?.source})`
    )
    await myFont.load()

    document.fonts.add(myFont)

    return selectedFont.family
}
